module.exports = __webpack_public_path__ + "img/nyomtatas-femgozolt-kartonra-thumb.f0d5ceeb.jpg";